import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { changeCurrentDevice } from './actions';
import onClickOutside from 'react-onclickoutside';
import { translate } from 'react-i18next';
import { changeCurrentJourney } from '../Sidebar/RidesSidebar/actions';

@translate(['header'], { wait: true })
@onClickOutside
class HeaderLeftNav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      subMenuOpened: false,
      q: ''
    };
    this.getFormClass = this.getFormClass.bind(this);
  }

  getFormClass() {
    return this.state.subMenuOpened ? 'header__select active' : 'header__select';
  }

  toggleMenu = (e) => {
    e.preventDefault();
    this.setState({
      subMenuOpened: !this.state.subMenuOpened,
      q: ''
    });
  };

  handleDeviceClick = (device) => {
    const {
      clearCurrentJourney,
      changeDevice,
      cj,
    } = this.props;
    if (cj) {
      clearCurrentJourney();
    }
    changeDevice(device);
    this.setState({ subMenuOpened: false });
  }

  search = (e) => {
    const value = e.target.value.toLowerCase();

    if (value.length == 0 ){
      this.setState({
        devices: null
      })
      return null
    }
    // search by name in devices
    let found_devices = this.props.devices.filter(item => item.name.toLowerCase().indexOf(value) > -1 )

    // search by vin/name in vehicles
    let found_vehicles = this.props.vehicles.filter(item => {
        let make = item.make || ''
        let model = item.model || ''
        let vin = item.vin || ''
        let number = item.number || ''

        return make.toLowerCase().indexOf(value) > -1 ||
               model.toLowerCase().indexOf(value) > -1 ||
               vin.toLowerCase().indexOf(value) > -1 ||
               number.toLowerCase().indexOf(value) > -1
      }
    )
    
    for(let i=0; i< found_vehicles.length; i++){
      let device = this.props.devices.filter(item => item.id === found_vehicles[i].deviceId ).pop()

      if (device){
        found_devices.push(device)
      }
    }

    this.setState({
      devices: found_devices
    })
  }

  render() {
    const { t } = this.props;
    const { devices, q } = this.state
    return (
      <div className="header__aside">
        <a href="#"><strong className="header__logo" /></a>
        {
          this.props.devices.length ?
            <form className={this.getFormClass()}>
              <a
                className="header__select__selected"
                onClick={this.toggleMenu}
              >{`${this.props.currentDevice.name.substring(0, 25)}${this.props.currentDevice.name.length > 25 ? '...' : ''}`}</a>
              <div className="header__select__submenu">
                <input type="text" className="car__search" onKeyUp={this.search} placeholder={t('header:search_placeholder')}/>
                { (devices || this.props.devices).map((device) => {
                  const selected = this.props.currentDevice.id === device.id;
                  const currentDeviceStats = this.props.devicesStats.filter(item => item.deviceId === device.id).pop() || {};
                  const currentDeviceStatistics = this.props.statistics.filter(item => item.deviceId === device.id).pop() || {};
                  const fuel_for = Math.floor(device.fuelTankCapacity * currentDeviceStats.fuelLevel / device.fuelConsumption)
                  const vehicle = this.props.vehicles.filter(item => {
                    return item.deviceId === device.id
                  }).pop() || {};
                  const vehicleNumber = vehicle && vehicle.number ? vehicle.number.match(/[\d\.]+|\D+/gmi) : [];
                  return (
                    <label key={device.id} className={`header__select__submenu__item con-level${this.props.connectionLevels[device.id] || 1}`}>
                      <input
                        type="radio"
                        value="m1"
                        name="header_select"
                        checked={this.props.currentDevice.id === device.id}
                        onChange={() => this.handleDeviceClick(device)}
                      />
                      <div className="connection-level-icon">
                        <i className={`connection-level level${this.props.connectionLevels[device.id] || 1}`} />
                      </div>
                      <div className="vehicle-info">
                        <div className={'header__select__submenu__item__holder'}>
                          <div className="header__select__submenu__item__name"
                                style={{
                                  fontFamily: selected ? 'FormularMedium' : 'FormularLight',
                                  overflow: 'hidden',
                                  lineHeight: '187%',
                                }}>{
                                  (device.name).length > 22 ? (
                                    (device.name).substring(0, 22) + '\n' +
                                    ((device.name).length > 40 ? (
                                      (device.name).substring(22, 40).trim() + '...'
                                    ) : (
                                      (device.name).substring(22)
                                    ))
                                  ) : (device.name).trim()
                                }</div>
                          <div className="header__select__submenu__item__number">
                            {vehicleNumber.map((part) => <span>{part}</span>)}
                          </div>
                          <div className="header__select__submenu__item__note">
                            {device.provideFuelLevel && !isNaN(fuel_for) &&
                              <span>
                                {t('header:fuel_for')}{ fuel_for }{t('header:km')}
                              </span>
                            }
                            { (!device.provideFuelLevel || isNaN(fuel_for)) &&
                              <span>&nbsp;</span>
                            }
                          </div>
                        </div>
                      </div>
                      
                    </label>
                  );
                }) }
                { devices && devices.length == 0 && 
                  <div className="not_found">
                    {t('header:not_found')}
                  </div>
                }
              </div>
            </form> : null
        }
      </div>
    );
  }

  handleClickOutside() {
    this.setState({
      subMenuOpened: false,
    });
  }
}

HeaderLeftNav.propTypes = {
  devices: PropTypes.array,
  currentDevice: PropTypes.object,
  devicesStats: PropTypes.array,
  changeDevice: PropTypes.func,
  statistics: PropTypes.array,
};

export default connect(
  state => ({
    cj: state.rides.currentJourney,
    devices: state.devices.devices,
    currentDevice: state.devices.currentDevice,
    connectionLevels: state.devices.devicesConnectionLevels,
    devicesStats: state.devices.devicesStats,
    statistics: state.statistics.statistics,
    vehicles: state.settings.vehicles
  }),
  dispatch => ({
    clearCurrentJourney() {
      return dispatch(changeCurrentJourney({ journey: null }));
    },
    changeDevice(device) {
      return dispatch(changeCurrentDevice({ device }));
    },
  }),
)(HeaderLeftNav);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLeftNav.js